import { types } from "./types";
import * as APIService from "../../../API/APIService";

if (!Object.entries)
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };

const actions = (dispatch, state) => {
  const setSuggestionsLoaded = () => {
    dispatch({
      type: types.SET_SUGGESTIONSLOADED_SUCCES,
      payload: {
        ...state.search,
        suggestionsLoaded: true,
      },
    });
  };

  const setDetailsLoaded = () => {
    dispatch({
      type: types.SET_DETAILS_LOADED_SUCCES,
      payload: {
        ...state.search,
        detailsLoaded: true,
      },
    });
  };

  const setSearchInputViaStorage = (value) => {
    value.distance = value.distance ? value.distance : 10;
    let placeInput = 0;
    let companyInput = 0;
    if (value.place) {
      placeInput = value.place.hasOwnProperty('Name') ? value.place.Name.length : 0;
    }
    if (value.company) {
      companyInput = value.company.hasOwnProperty('Name') ? value.company.Name.length : 0;
    }
    dispatch({
      type: types.SET_SEARCH_INPUT_VIA_STORAGE,
      payload: {
        ...state.search,
        searchInput: value,
        inputFound: placeInput === 0 && companyInput === 0 ? false : true,
      },
    });
  };

  const setSearchInput = (searchInputData, inputCategory) => {
    dispatch({
      type: types.SET_SEARCH_INPUT,
      payload: {
        ...state.search,
        searchInput: {
          ...state.search.searchInput,
          [inputCategory]: searchInputData,
        },
      },
    });
    sessionStorage.setItem(
      "TNLZSInput",
      JSON.stringify([
        {
          ...state.search.searchInput,
          [inputCategory]: searchInputData,
        },
      ])
    );
  };

  const getDetails = (path) => {
    APIService.getData(path).then((results) => {
      setDetails(results.data);
    });
  };

  const setDetails = (data) => {
    let certificatesUsed = [];
    data.CompanyDetails.map((company) => {
      let certificatesNew = [];
      let certificatesFromCompany =
        company.Kwaliteitreg && company.Kwaliteitreg.length > 0
          ? company.Kwaliteitreg.split(",")
          : null;

      certificatesNew =
        certificatesFromCompany && certificatesFromCompany.length > 0
          ? [...certificatesFromCompany.map((cert) => parseInt(cert))]
          : certificatesUsed;

      certificatesUsed = certificatesUsed.concat(
        certificatesNew.filter((item) => certificatesUsed.indexOf(item) < 0)
      );
    });

    dispatch({
      type: types.SET_DETAILS,
      payload: {
        ...state.search,
        suggestions: {
          ...state.search.suggestions,
          Kwaliteitsregelingen: [],
        },
        details: data.CompanyDetails,
        certificatesActive: certificatesUsed,
        detailsLoaded: true,
      },
    });
    sessionStorage.setItem("TNLZSDetails", JSON.stringify(data));
  };

  const getSuggestionsData = (path) => {
    APIService.getData(path).then((results) => {
      setSuggestionsData(results.data);
    });
  };

  const setSuggestionsData = (data) => {
    const suggestions = { ...state.search.suggestions };

    for (var key in data) {
      suggestions[key] = data[key].map((value) => {
        value.searchCategory = key;
        value.Name = value.Keyword ? value.Keyword : value.Name;
        value.Keyword ? delete value.Keyword : null;
        value.Id = value.specialismeId ? value.specialismeId : value.Id;
        return value;
      });
    }
    /*
    for (const [category, values] of Object.entries(data)) {
      suggestions[category] = values.map((value) => {
        value.searchCategory = category;
        value.Name = value.Keyword ? value.Keyword : value.Name;
        value.Keyword ? delete value.Keyword : null;
        value.Id = value.specialismeId ? value.specialismeId : value.Id;
        return value;
      });
    }
*/

    dispatch({
      type: types.SET_SUGGESTIONS_DATA,
      payload: {
        ...state.search,
        suggestions,
      },
    });

    sessionStorage.setItem("TNLZSSuggestions", JSON.stringify(suggestions));
  };

  const getPlaces = (path) => {
    APIService.getData(path).then((results) => {
      setPlaces(results.data.Places);
    });
  };

  const setPlaces = (data) => {
    dispatch({
      type: types.SET_PLACES,
      payload: {
        ...state.search,
        suggestions: {
          ...state.search.suggestions,
          Places: data,
        },
      },
    });

    localStorage.setItem("TNLZSPlaces", JSON.stringify(data));
  };

  const setRadiusDistance = (radius) => {
    dispatch({
      type: types.SET_RADIUS_DISTANCE,
      payload: {
        ...state.search,
        searchInput: {
          ...state.search.searchInput,
          distance: radius,
        },
      },
    });
    sessionStorage.setItem(
      "TNLZSInput",
      JSON.stringify([
        {
          ...state.search.searchInput,
          distance: radius,
        },
      ])
    );
  };

  const setSearchQualityScheme = (data) => {
    dispatch({
      type: types.SET_QUALITY_SCHEME,
      payload: {
        ...state.search,
        searchInput: {
          ...state.search.searchInput,
          qualityScheme: data,
        },
      },
    });
    sessionStorage.setItem(
      "TNLZSInput",
      JSON.stringify([
        {
          ...state.search.searchInput,
          qualityScheme: data,
        },
      ])
    );
  };

  return {
    setSuggestionsLoaded,
    getDetails,
    setDetails,
    getSuggestionsData,
    getPlaces,
    setSuggestionsData,
    setPlaces,
    setSearchInput,
    setDetailsLoaded,
    setSearchInputViaStorage,
    setRadiusDistance,
    setSearchQualityScheme,
  };
};

export { actions };
